module.exports = __webpack_public_path__ + "static/media/37-4.241244c0.mp3";